<div *ngIf="initialized">
  <div class="card mb-0">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Download Assessment PDF</h3>

          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body mb-4">
        <form id="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
          Download a PDF of this assessment
        </form>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
          </div>
          <div class="col text-right">
            <button type="submit" form="form" [promiseBtn]="submitComplete" class="btn btn-primary">Download PDF</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="my_mm" style="height:100mm;display:none;"></div>


<div class="row my-0 mx-0">
  <div *ngIf="ready" class="col-12 text-center mb-7 mt-2">
    <page-load-header></page-load-header>
    <h3>Generating PDF... Do not close...</h3>
  </div>

  <div *ngIf="ready" style="width: 800px;">
    <div id="printDiv" class="row">
      <div class="col-12">
        <loading-levels-result-details *ngIf="assessmentType == assessmentTypeValues.LoadingLevels" [assessmentId]="assessmentId" [isPrintVersion]="true"></loading-levels-result-details>
        <assessment-result-details *ngIf="assessmentType == assessmentTypeValues.RRA" [assessmentId]="assessmentId" [isPrintVersion]="true"></assessment-result-details>
        <gaitcapability-assessment-result-details *ngIf="assessmentType == assessmentTypeValues.GaitCapability" [assessmentId]="assessmentId" [isPrintVersionUserId]="userId" [isPrintVersion]="true"></gaitcapability-assessment-result-details>
      </div>
    </div>
  </div>

</div>


